import { BaseService } from "../BaseService";

export interface EnumOption {
  value: string;
  label: string;
}

export type EnumMap = Record<string, EnumOption[]>;

export class EnumsService extends BaseService {
  public async getAll(): Promise<EnumMap> {
    return this.getRequest("/enums");
  }
}

export const enumsService = new EnumsService();
